import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Switch, Redirect } from "react-router-dom";

import CONSTANTS from "../../constants";
import PremiumServiceItem from "./premiumServiceItem";
import StepHeadline from "../Titles/StepHeadline";
import LayoutStandardWidth from "../../layouts/LayoutStandardWidth";
import {
  headTitleTag,
  getNewPhoneFormatValue,
  removeNumbers,
} from "../../helpers/functions";
import { pushToGTMTracker } from "../../helpers/trackerManager";
import { Button, Input, CheckBox, Radio, Select } from "../Forms/Forms";
import fetchApiData from "../apiHandlers/fetchApiData";
import {
  setPersonalInformations,
  CurrentStepSetAction,
  setSelectedPremiumServicesToStore,
  setListPremiumServicesToStore,
  setSelectedPremiumServicesDsValetToStore,
} from "../../actions/action";
import "./myInfos.css";
import arrowExpand from "../../images/AP/common_right_arrow.svg";
import InputOutlined from "../Forms/InputOutlined";

const mapStateToProps = (state) => state;
const mapDispatchToProps = {
  setPersonalInformations,
  CurrentStepSetAction,
  setSelectedPremiumServicesToStore,
  setListPremiumServicesToStore,
  setSelectedPremiumServicesDsValetToStore,
};
const BRAND_NAME_STRING_TOREPLACE = "[nom-marque]";
const FIELED_NAME_STRING_TOREPLACE = "[nom_du_champ]";

class MyInfos extends PureComponent {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      pageLoaded: false,
      civilityInput: this.props.store.personalInfos.civilityCode || "",
      firstNameInput: this.props.store.personalInfos.firstname || "",
      lastNameInput: this.props.store.personalInfos.name || "",
      emailInput: this.props.store.personalInfos.mail || "",
      phoneInput: this.props.store.personalInfos.phone || "",
      phone: "",
      contactModeInput: this.props.store.personalInfos.contactMode,
      contactModeOption: "",
      acceptCommercialChoice:
        this.props.store.personalInfos.ConsentToAcceptCommercialChoice || false,
      commercialEmailChoice:
        this.props.store.personalInfos.ConsentEmail || false,
      commercialTelChoice: this.props.store.personalInfos.ConsentTel || false,
      commercialSmsChoice: this.props.store.personalInfos.ConsentSms || false,
      commercialAdressChoice:
        this.props.store.personalInfos.ConsentAddress || false,
      commercialOtherChoice:
        this.props.store.personalInfos.ConsentOther || false,
      islegalChoiceChecked:
        this.props.store.personalInfos.acceptLegalNotices ||
        !!!Number(window.siteConfig.DisplayGDPR),
        isActivateTurquieConsent: !!Number(
          window.siteConfig.ActivateTurquieConsent
        ),
      showFormErrors: false,
      selectedPremiumServices: this.props.store.selectedPremiumServices || [],
      selectedDsValetPremiumServicesId:
        this.props.store.selectedDsValetPremiumServices || [],
      premiumServicesCodeIntern: [],
      goToNextStep: false,
      servicePremiumAlreadyChoosen: Object.values(
        this.props.store.selectedPremiumServices
      ).length
        ? Object.keys(this.props.store.selectedPremiumServices)[0]
        : 0,
      intervalId: 0,
      solutionMobilite:
        this.props.store.personalInfos.solutionMobilite || false,
      premiumServiceSelfReception:
        this.props.store.personalInfos.premiumServiceSelfReception || false,
      showFirstNameFormatError: false,
      showSpecialCharFormatError: false,
      showFirstNameMaxLengthError: false,
      showNameFormatError: false,
      showNameSpecialCharError: false,
      showNameMaxLengthError: false,
      listPremiumServices: this.props.store.listPremiumServices || [],
      legalNoticeMarginTop: 0,
      confirmButtonMarginBottom: 0,
      showOptionPremiumSerives: false,
      isNewConsentActive: !!Number(
        window.siteConfig.ActiverNouveauxConsentements
      ),
      isNewConsentExpanded: false,
      marketingProfilingInput: this.initConsentMarketingProfiling(),
      marketingInput:
        this.props.store.personalInfos.ConsentMarketing !== undefined
          ? this.props.store.personalInfos.ConsentMarketing
          : "",
      profilingInput:
        this.props.store.personalInfos.ConsentProfiling !== undefined
          ? this.props.store.personalInfos.ConsentProfiling
          : "",
      thirdPartyInput:
        this.props.store.personalInfos.ConsentThirdParty !== undefined
          ? this.props.store.personalInfos.ConsentThirdParty
          : "",
      isValidFirstName:
        this.props.store.personalInfos.firstname.length > 0 ? true : false,
      isValidLastName:
        this.props.store.personalInfos.name.length > 0 ? true : false,
      isValidEmail:
        this.props.store.personalInfos.mail.length > 0 ? true : false,
    };
    this.ActivateMentionLegal = !!Number(window.siteConfig.DisplayGDPR);
    this.acceptCommercialChoiceCheckboxIsActivated = !!Number(
      window.siteConfig.TypeContactCheck
    );
    this.isPhoneNumberOptional = !!Number(
      window.siteConfig.MakePhoneNumberOptional
    );
    this.phoneInput = React.createRef();
    this.formRef = React.createRef();
    this.legalNoticeRef = React.createRef();
    this.servicepremiumRef = React.createRef();
    this.formCitroenRef = React.createRef();

    this.validateFormInputs = this.validateFormInputs.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
  }

  initConsentMarketingProfiling() {
    if (
      this.props.store.personalInfos.ConsentMarketingProfiling !== undefined
    ) {
      return this.props.store.personalInfos.ConsentMarketingProfiling;
    } else if (
      this.props.store.personalInfos.ConsentMarketing !== undefined &&
      this.props.store.personalInfos.ConsentProfiling !== undefined
    ) {
      return (
        this.props.store.personalInfos.ConsentMarketing ||
        this.props.store.personalInfos.ConsentProfiling
      );
    } else return "";
  }

  componentWillMount() {
    this._isMounted = true;
  }

  componentDidMount() {
    this.getServicePremium();
    this.setState({
      selectedPremiumServices: this.state.selectedPremiumServices.filter(
        (item) => item.groupe.toLowerCase() !== "dsvalet"
      ),
    });
    window.scrollTo(0, 0);
    pushToGTMTracker(
      "personal-page",
      window.siteConfig.v2infospersos.Title.replace(
        BRAND_NAME_STRING_TOREPLACE,
        CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()
      )
    );
    this.checkContactModeSelectedOption();
  }

  componentDidUpdate() {
    if (CONSTANTS.SITE_INFO.BRAND_CODE !== "C") {
      window.isMobile() === "desktop" &&
        this.servicepremiumRef.current.offsetHeight -
          this.formRef.current.offsetHeight >=
          0 &&
        this.setState({
          legalNoticeMarginTop:
            this.servicepremiumRef.current.offsetHeight -
            this.formRef.current.offsetHeight,
        });
      const buttonMarginBottom =
        this.servicepremiumRef.current.offsetHeight -
        (this.formRef.current.offsetHeight +
          this.legalNoticeRef.current.offsetHeight);
      window.isMobile() === "desktop" &&
        buttonMarginBottom >= 0 &&
        this.setState({ confirmButtonMarginBottom: buttonMarginBottom - 80 });
    }
  }

  checkContactModeSelectedOption = () => {
    if (this.state.contactModeInput === CONSTANTS.LABELS.userinfos_tel) {
      this.setState({ contactModeOption: "telOption" });
    } else if (this.state.contactModeInput === CONSTANTS.LABELS.userinfos_sms) {
      this.setState({ contactModeOption: "smsOption" });
    } else {
      this.setState({ contactModeOption: "emailOption" });
      this.setState({ contactModeInput: CONSTANTS.LABELS.userinfos_email });
    }
  };

  getServicePremium() {
    const SERVICES_PREMIUM = new fetchApiData();
    SERVICES_PREMIUM.getServicePremium()
      .then((data) => {
        let showBlock =
          data.d.some((service) => service.displayPI) &&
          data.d.some((premService) =>
            this.props.store.dealer.ListeIdSP.includes(
              premService.idServicePremium
            )
          );
        this.setState({ showOptionPremiumSerives: showBlock });
        this.setState({ listPremiumServices: data.d });
        this.props.setListPremiumServicesToStore(data.d);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  validateFormInputs() {
    const phoneregex = this.isPhoneNumberOptional
      ? `^$|${CONSTANTS.SITE_INFO.PHONEREGEX.replace(/\//g, "")}`
      : CONSTANTS.SITE_INFO.PHONEREGEX.replace(/\//g, "");
    const newRegex = new RegExp(phoneregex);
    if (
      !this.state.firstNameInput.length ||
      !this.state.lastNameInput.length ||
      (this.state.civilityInput !== "Common_Sir" &&
        this.state.civilityInput !== "Common_Madam" &&
        this.state.civilityInput !== "Common_Neutre") ||
      !this.state.emailInput.length ||
      !newRegex.test(getNewPhoneFormatValue(this.state.phoneInput))
    ) {
      this.setState({ showFormErrors: true });
      return false;
    } else {
      this.setState({ showFormErrors: false });
      this.props.setSelectedPremiumServicesToStore(
        this.state.selectedPremiumServices.concat(
          this.state.selectedDsValetPremiumServicesId
        )
      );
      this.props.setSelectedPremiumServicesDsValetToStore(
        this.state.selectedDsValetPremiumServicesId
      );
      this.props.setPersonalInformations({
        civilityCode: this.state.civilityInput,
        firstname: this.state.firstNameInput,
        name: this.state.lastNameInput,
        mail: this.state.emailInput,
        phone: this.state.phoneInput,
        contactMode: this.state.contactModeInput,
        solutionMobilite: this.state.premiumServicesCodeIntern.includes("OM"),
        premiumServiceSelfReception: this.state.premiumServiceSelfReception,
        ConsentToAcceptCommercialChoice: this.state.acceptCommercialChoice,
        ConsentEmail: this.state.commercialEmailChoice,
        ConsentTel: this.state.commercialTelChoice,
        ConsentSms: this.state.commercialSmsChoice,
        ConsentAddress: this.state.commercialAdressChoice,
        ConsentOther: this.state.commercialOtherChoice
          ? CONSTANTS.LABELS.userinfos_consent_checkbox_other
          : "",
        offerCompany: true,
        offerOppose: false,
        acceptLegalNotices: this.state.islegalChoiceChecked,
        withPay: false,
        RdvUpdated: true,
        IdRdv: 0,
        ConsentMarketing: this.state.isNewConsentActive
          ? this.state.marketingInput
          : false,
        ConsentProfiling: this.state.isNewConsentActive
          ? this.state.profilingInput
          : false,
        ConsentThirdParty: this.state.isNewConsentActive
          ? this.state.thirdPartyInput
          : false,
        ConsentMarketingProfiling: this.state.marketingProfilingInput,
      });

      this.props.CurrentStepSetAction(6);

      return true;
    }
  }

  scrollStep() {
    let elements = document.getElementsByClassName("error");
    let positionElement =
      Math.round(elements[0].getBoundingClientRect().top) - 45;

    window.scroll(0, positionElement);

    if (window.pageYOffset === positionElement) {
      clearInterval(this.state.intervalId);
    }
  }

  scrollToTop() {
    if (CONSTANTS.SITE_INFO.BRAND_CODE !== "C") {
      this.setState({ goToNextStep: false });
      const intervalId = setInterval(this.scrollStep.bind(this), 20);
      this.setState({ intervalId: intervalId });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getAlertLabelFirstNameError() {
    if (this.state.showFirstNameFormatError) {
      return CONSTANTS.LABELS.userinfos_error_nameformat;
    } else if (this.state.showSpecialCharFormatError) {
      return CONSTANTS.LABELS.userinfos_error_name_special_char;
    } else if (this.state.showFirstNameMaxLengthError) {
      return CONSTANTS.LABELS.userinfos_error_name_max_length;
    } else return "";
  }

  getAlertLabelNameError() {
    if (this.state.showNameFormatError) {
      return CONSTANTS.LABELS.userinfos_error_nameformat;
    } else if (this.state.showNameSpecialCharError) {
      return CONSTANTS.LABELS.userinfos_error_name_special_char;
    } else if (this.state.showNameMaxLengthError) {
      return CONSTANTS.LABELS.userinfos_error_name_max_length;
    } else return "";
  }

  isMobile() {
    if (window.outerWidth <= 800) {
      return "mobile";
    } else {
      return "desktop";
    }
  }

  render() {
    const SEO_TITLE =
      window.siteConfig.v2infospersos != undefined
        ? window.siteConfig.v2infospersos.Title
        : "";
    const SEO_DESC =
      window.siteConfig.v2infospersos != undefined
        ? window.siteConfig.v2infospersos.MetaDescription
        : "";
    const ActivateEmail = !!Number(window.siteConfig.ActivateEmail);
    const ActivateTelephone = !!Number(window.siteConfig.ActivateTelephone);
    const ActivateSMS = !!Number(window.siteConfig.ActivateSMS);
    const ActivatePostmail = !!Number(window.siteConfig.ActivatePostmail);
    const ActivateOther = !!Number(window.siteConfig.ActivateOther);
    const ShowGenderNeutre = !!Number(window.siteConfig["LocalNeutre"]);

    const dsValetPremiumServicesList = this.state.listPremiumServices.filter(
      (service) => service.groupe.toLowerCase() === "dsvalet"
    );
    let options = {
      telOption: CONSTANTS.LABELS.userinfos_tel,
      smsOption: CONSTANTS.LABELS.userinfos_sms,
      emailOption: CONSTANTS.LABELS.userinfos_email,
    };
    let checkBoxDisabledClass = "";
    if (this.isPhoneNumberOptional && !this.state.phoneInput.length) {
      options = { emailOption: CONSTANTS.LABELS.userinfos_email };
      checkBoxDisabledClass = "checkbox-disabled";
      const smsTelCheckBox = document.querySelectorAll("#tel,#sms");
      for (var i = 0; i < smsTelCheckBox.length; i++) {
        smsTelCheckBox[i].checked = false;
      }
      this.setState({
        commercialTelChoice: false,
        commercialSmsChoice: false,
        contactModeInput: CONSTANTS.LABELS.userinfos_email,
        contactModeOption: "emailOption",
      });
    }
    return (
      <React.Fragment>
        {headTitleTag(
          SEO_TITLE.replace(
            BRAND_NAME_STRING_TOREPLACE,
            CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()
          ),
          SEO_DESC.replace(
            BRAND_NAME_STRING_TOREPLACE,
            CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()
          )
        )}
        {this.state.goToNextStep && (
          <Switch>
            <Redirect
              key="from-list"
              to={{ pathname: CONSTANTS.SITE_ROUTS.SUMMARYPAGE }}
            />
          </Switch>
        )}
        <StepHeadline
          Title={CONSTANTS.LABELS.summary_userinfos}
          SubTitle={CONSTANTS.LABELS.userinfos_subtitle}
        />

        {/* Other Brands block */}
        {CONSTANTS.SITE_INFO.BRAND_CODE !== "C" && (
          <LayoutStandardWidth classes="container-specific-width">
            <div className="personnel_infos">
              <div
                ref={this.formRef}
                className="personnel_infos_forms half-block"
              >
                <div className="personnel_infos_forms-wrapper">
                  <div className="form-ligne civility">
                    <div className="row section-label">
                      <span tabIndex="0">
                        {CONSTANTS.LABELS.userinfos_civility}
                      </span>
                    </div>
                    <div className="row section-form">
                      <Radio
                        name="civility"
                        id="civility-M"
                        label={CONSTANTS.LABELS.userinfos_mister}
                        value="Common_Sir"
                        isChecked={this.state.civilityInput == "Common_Sir"}
                        onChange={(e) =>
                          this.setState({ civilityInput: e.target.value })
                        }
                      />
                      <Radio
                        name="civility"
                        id="civility-F"
                        label={CONSTANTS.LABELS.userinfos_madam}
                        value="Common_Madam"
                        isChecked={this.state.civilityInput == "Common_Madam"}
                        onChange={(e) =>
                          this.setState({ civilityInput: e.target.value })
                        }
                      />
                      {ShowGenderNeutre && (
                        <Radio
                          name="civility"
                          id="civility-N"
                          label={CONSTANTS.LABELS.userinfos_neutral}
                          value="Common_Neutre"
                          isChecked={
                            this.state.civilityInput == "Common_Neutre"
                          }
                          onChange={(e) =>
                            this.setState({ civilityInput: e.target.value })
                          }
                        />
                      )}
                      {this.state.showFormErrors &&
                        this.state.civilityInput !== "Common_Sir" &&
                        this.state.civilityInput !== "Common_Madam" &&
                        this.state.civilityInput !== "Common_Neutre" && (
                          <span className="error input-errorLabel">
                            {CONSTANTS.LABELS.userinfos_error.replace(
                              FIELED_NAME_STRING_TOREPLACE,
                              CONSTANTS.LABELS.userinfos_civility
                            )}
                          </span>
                        )}
                    </div>
                  </div>
                  <div className="form-ligne client-lastname">
                    <div className="row section-label">
                      <span>{CONSTANTS.LABELS.userinfos_firstname}</span>
                    </div>
                    <div className="row section-form">
                      <div className="form-wrapper">
                        <Input
                          ariaLabel={CONSTANTS.LABELS.userinfos_firstname}
                          defaultValue={this.state.firstNameInput}
                          Value={this.state.firstNameInput}
                          name={"firstName"}
                          autoComplete={"on"}
                          onChange={(e) => {
                            if (e.target.value.trim().match(/[0-9]/g)) {
                              this.setState({
                                firstNameInput: removeNumbers(
                                  e.target.value.trim()
                                ),
                                showFirstNameFormatError: true,
                                showSpecialCharFormatError: false,
                                showFirstNameMaxLengthError: false,
                              });
                            } else if (
                              e.target.value.match(/[^\p{L}\p{M}\s']/gu)
                            ) {
                              this.setState({
                                showSpecialCharFormatError: true,
                                showFirstNameMaxLengthError: false,
                                showFirstNameFormatError: false,
                              });
                            } else if (e.target.value.length > 50) {
                              this.setState({
                                showFirstNameMaxLengthError: true,
                                showFirstNameFormatError: false,
                                showSpecialCharFormatError: false,
                              });
                            } else {
                              this.setState({
                                firstNameInput: e.target.value,
                                showFirstNameFormatError: false,
                                showSpecialCharFormatError: false,
                                showFirstNameMaxLengthError: false,
                              });
                            }
                          }}
                          isInvalid={
                            this.state.showFormErrors &&
                            this.state.firstNameInput.length < 2 &&
                            CONSTANTS.LABELS.userinfos_error.replace(
                              FIELED_NAME_STRING_TOREPLACE,
                              CONSTANTS.LABELS.userinfos_firstname
                            )
                          }
                          alert={this.getAlertLabelFirstNameError()}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-ligne client-firstname">
                    <div className="row section-label">
                      <span>{CONSTANTS.LABELS.userinfos_lastname}</span>
                    </div>
                    <div className="row section-form">
                      <div className="form-wrapper">
                        <Input
                          ariaLabel={CONSTANTS.LABELS.userinfos_lastname}
                          defaultValue={this.state.lastNameInput}
                          Value={removeNumbers(this.state.lastNameInput)}
                          name={"lastName"}
                          autoComplete={"on"}
                          onChange={(e) => {
                            if (e.target.value.trim().match(/[0-9]/g)) {
                              this.setState({
                                lastNameInput: removeNumbers(
                                  e.target.value.trim()
                                ),
                                showNameFormatError: true,
                                showNameSpecialCharError: false,
                                showNameMaxLengthError: false,
                              });
                            } else if (
                              e.target.value.match(/[^\p{L}\p{M}\s']/gu)
                            ) {
                              this.setState({
                                showNameSpecialCharError: true,
                                showNameFormatError: false,
                                showNameMaxLengthError: false,
                              });
                            } else if (e.target.value.length > 50) {
                              this.setState({
                                showNameMaxLengthError: true,
                                showNameSpecialCharError: false,
                                showNameFormatError: false,
                              });
                            } else {
                              this.setState({
                                lastNameInput: e.target.value,
                                showNameSpecialCharError: false,
                                showNameFormatError: false,
                                showNameMaxLengthError: false,
                              });
                            }
                          }}
                          isInvalid={
                            this.state.showFormErrors &&
                            this.state.lastNameInput.length < 2 &&
                            CONSTANTS.LABELS.userinfos_error.replace(
                              FIELED_NAME_STRING_TOREPLACE,
                              CONSTANTS.LABELS.userinfos_lastname
                            )
                          }
                          alert={this.getAlertLabelNameError()}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-ligne client-email">
                    <div className="row section-label">
                      <span>{CONSTANTS.LABELS.userinfos_email}</span>
                    </div>
                    <div className="row section-form">
                      <div className="form-wrapper">
                        <Input
                          ariaLabel={CONSTANTS.LABELS.userinfos_email}
                          name="email"
                          // Type='email'
                          autoComplete={"on"}
                          placeholder={CONSTANTS.SITE_INFO.EMAILMASK}
                          defaultValue={this.state.emailInput}
                          onChange={(e) =>
                            this.setState({
                              emailInput: e.target.value.match(
                                /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}/g
                              )
                                ? e.target.value.toLowerCase().trim()
                                : "",
                            })
                          }
                          isInvalid={
                            this.state.showFormErrors &&
                            !this.state.emailInput.match(
                              /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}/g
                            ) &&
                            CONSTANTS.LABELS.userinfos_error.replace(
                              FIELED_NAME_STRING_TOREPLACE,
                              CONSTANTS.LABELS.userinfos_email
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-ligne client-tel">
                    <div className="row section-label">
                      <span>{CONSTANTS.LABELS.userinfos_tel}</span>
                    </div>
                    <div className="row section-form">
                      <div className="form-wrapper">
                        <Input
                          ariaLabel={CONSTANTS.LABELS.userinfos_tel}
                          Type="tel"
                          name="tel"
                          autoComplete={"on"}
                          placeholder={getNewPhoneFormatValue(
                            CONSTANTS.SITE_INFO.PHONEMASK
                          )}
                          Value={getNewPhoneFormatValue(this.state.phoneInput)}
                          onChange={(e) => {
                            if (
                              e.currentTarget.value.match(
                                CONSTANTS.SITE_INFO.PHONEREGEX
                              )
                            ) {
                              this.setState({
                                phoneInput: e.currentTarget.value.trim(),
                              });
                            } else if (
                              Number(e.currentTarget.value) < 1 &&
                              e.currentTarget.value.length > 1
                            ) {
                              this.setState({
                                phoneInput: e.currentTarget.value.slice(0, -1),
                              });
                            } else {
                              this.setState({
                                phoneInput: getNewPhoneFormatValue(
                                  e.currentTarget.value.trim()
                                ),
                              });
                            }
                          }}
                          isInvalid={
                            this.state.showFormErrors &&
                            !getNewPhoneFormatValue(
                              this.state.phoneInput
                            ).match(CONSTANTS.SITE_INFO.PHONEREGEX) &&
                            (Number(this.state.phoneInput) < 1 ||
                              this.state.phoneInput.length !== 20) &&
                            CONSTANTS.LABELS.userinfos_error.replace(
                              FIELED_NAME_STRING_TOREPLACE,
                              CONSTANTS.LABELS.userinfos_tel
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-ligne client-contact-mod">
                    <div className="row section-label">
                      <span>{CONSTANTS.LABELS.userinfos_contact_mode}</span>
                    </div>
                    <div className="row section-form">
                      <div className="form-wrapper">
                        <Select
                          ariaLabel={CONSTANTS.LABELS.userinfos_contact_mode}
                          Options={options}
                          Selected={this.state.contactModeOption}
                          Name="contactChoice"
                          onChange={(e) => {
                            this.setState({
                              contactModeOption: e.target.value.trim(),
                            });
                            this.setState({
                              contactModeInput: e.target.options[
                                e.target.selectedIndex
                              ].text.trim(),
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                ref={this.servicepremiumRef}
                className="personnel_infos_services half-block"
              >
                {this.state.showOptionPremiumSerives && (
                  <div className="personnel_infos_services-wrapper">
                    <h4 tabIndex="0" className="premium_services-headline">
                      {CONSTANTS.LABELS.userinfos_options_title}
                      <span
                        className="premium_services-subtitle"
                        dangerouslySetInnerHTML={{
                          __html: CONSTANTS.LABELS.userinfos_options_subtitlel,
                        }}
                      ></span>
                    </h4>
                    {/* premium service ds-valet */}
                    {CONSTANTS.SITE_CONFIG.currentBrand === "D" &&
                      dsValetPremiumServicesList.length !== 0 && (
                        <div className="premium_services-item">
                          <div className="item-title">
                            <h4
                              tabIndex="0"
                              className="item-title-name"
                              dangerouslySetInnerHTML={{
                                __html:
                                  CONSTANTS.LABELS.userinfos_dsvalet_title,
                              }}
                            ></h4>
                          </div>
                          <div className="item-body">
                            <p
                              tabIndex="0"
                              className="item-body-content"
                              dangerouslySetInnerHTML={{
                                __html:
                                  CONSTANTS.LABELS
                                    .userinfos_dsvalet_description,
                              }}
                            ></p>
                            <u className="item-body-services">
                              {dsValetPremiumServicesList.map(
                                (premiumServiceItem) => {
                                  return (
                                    <li
                                      className="item-service"
                                      key={premiumServiceItem.idServicePremium}
                                    >
                                      <h6
                                        className="item-service-title"
                                        dangerouslySetInnerHTML={{
                                          __html: premiumServiceItem.titre,
                                        }}
                                      ></h6>
                                      <div className="item-service-block">
                                        <p
                                          className="item-service-info"
                                          dangerouslySetInnerHTML={{
                                            __html: premiumServiceItem.label,
                                          }}
                                        ></p>
                                        <Radio
                                          name="dsValet"
                                          //label={premiumServiceItem.label}
                                          id={
                                            premiumServiceItem.idServicePremium
                                          }
                                          value={premiumServiceItem.titre}
                                          isChecked={
                                            this.state
                                              .selectedDsValetPremiumServicesId
                                              .idServicePremium ===
                                            premiumServiceItem.idServicePremium
                                          }
                                          onChange={(e) => {
                                            this.setState({
                                              selectedPremiumServices: Object.values(
                                                this.state
                                                  .selectedPremiumServices
                                              ).filter((item) => {
                                                return (
                                                  item.Name != e.target.name
                                                );
                                              }),
                                            });
                                            this.setState({
                                              selectedDsValetPremiumServicesId: [
                                                {
                                                  idServicePremium:
                                                    premiumServiceItem.idServicePremium,
                                                  groupe:
                                                    premiumServiceItem.groupe,
                                                },
                                              ],
                                            });
                                          }}
                                        />
                                      </div>
                                    </li>
                                  );
                                }
                              )}
                            </u>
                            <p
                              className="item-body-link"
                              dangerouslySetInnerHTML={{
                                __html:
                                  CONSTANTS.LABELS.userinfos_dsvalet_info_title,
                              }}
                            ></p>
                            <p
                              className="item-body-legalNotice"
                              dangerouslySetInnerHTML={{
                                __html:
                                  CONSTANTS.LABELS
                                    .userinfos_dsvalet_info_description,
                              }}
                            ></p>
                          </div>
                        </div>
                      )}
                    {this.state.listPremiumServices.map((premService) => {
                      return (
                        premService.displayPI &&
                        this.props.store.dealer.ListeIdSP.includes(
                          premService.idServicePremium
                        ) && (
                          <PremiumServiceItem
                            Title={premService.titre}
                            Price={""}
                            Description={premService.label}
                            Name={premService.titre}
                            Label={CONSTANTS.LABELS.userinfos_options_checkbox}
                            isSelected={this.state.selectedPremiumServices.some(
                              (elemt) =>
                                elemt.idServicePremium ===
                                premService.idServicePremium
                            )}
                            onChange={(e) => {
                              e.target.checked
                                ? this.setState({
                                    selectedPremiumServices: [
                                      ...this.state.selectedPremiumServices,
                                      {
                                        idServicePremium:
                                          premService.idServicePremium,
                                        groupe: premService.groupe,
                                      },
                                    ],
                                    premiumServicesCodeIntern: [
                                      ...this.state.premiumServicesCodeIntern,
                                      premService.codeIntern,
                                    ],
                                  })
                                : this.setState({
                                    selectedPremiumServices: this.state.selectedPremiumServices.filter(
                                      (item) =>
                                        item.idServicePremium !==
                                        premService.idServicePremium
                                    ),
                                  });
                            }}
                          />
                        )
                      );
                    })}
                  </div>
                )}
              </div>

              <div
                ref={this.legalNoticeRef}
                style={{
                  marginTop:
                    CONSTANTS.SITE_CONFIG.currentBrand === "D" &&
                    -this.state.legalNoticeMarginTop,
                }}
                className="commercial_services_from"
              >
                {!this.state.isNewConsentActive && (
                  <React.Fragment>
                    <div
                      tabIndex="0"
                      dangerouslySetInnerHTML={{
                        __html: CONSTANTS.LABELS.userinfos_consent_block1,
                      }}
                    ></div>

                    {this.acceptCommercialChoiceCheckboxIsActivated ? (
                      <CheckBox
                        wrapperClasses="accept-commercial-choice"
                        id="accept-commercials"
                        onClick={(e) => {
                          var cbs = document.getElementsByClassName(
                            "commercial-choice"
                          );
                          for (var i = 0; i < cbs.length; i++) {
                            cbs[i].firstChild.checked = false;
                          }
                          this.setState({
                            acceptCommercialChoice: e.target.checked,
                            commercialEmailChoice: false,
                            commercialTelChoice: false,
                            commercialSmsChoice: false,
                            commercialAdressChoice: false,
                            commercialOtherChoice: false,
                          });
                        }}
                        label={CONSTANTS.LABELS.userinfos_consent_block2}
                        isChecked={
                          this.props.store.personalInfos
                            .ConsentToAcceptCommercialChoice
                        }
                      />
                    ) : (
                      <div>
                        <p
                          tabIndex="0"
                          dangerouslySetInnerHTML={{
                            __html: CONSTANTS.LABELS.userinfos_consent_block2,
                          }}
                        ></p>
                      </div>
                    )}

                    <div
                      aria-disabled={
                        !this.state.acceptCommercialChoice &&
                        this.acceptCommercialChoiceCheckboxIsActivated
                      }
                      className={
                        !this.state.acceptCommercialChoice &&
                        this.acceptCommercialChoiceCheckboxIsActivated
                          ? "is-disabled"
                          : ""
                      }
                    >
                      {ActivateEmail && (
                        <CheckBox
                          wrapperClasses="commercial-choice"
                          id="email"
                          onClick={(e) =>
                            this.setState({
                              commercialEmailChoice: e.target.checked,
                            })
                          }
                          label={
                            CONSTANTS.LABELS.userinfos_consent_checkbox_email
                          }
                          isChecked={
                            this.props.store.personalInfos.ConsentEmail
                          }
                        />
                      )}
                      {ActivateTelephone && (
                        <CheckBox
                          wrapperClasses={`commercial-choice ${checkBoxDisabledClass}`}
                          id="tel"
                          onClick={(e) =>
                            this.setState({
                              commercialTelChoice: e.target.checked,
                            })
                          }
                          label={
                            CONSTANTS.LABELS.userinfos_consent_checkbox_tel
                          }
                          isChecked={this.props.store.personalInfos.ConsentTel}
                        />
                      )}
                      {ActivateSMS && (
                        <CheckBox
                          wrapperClasses={`commercial-choice ${checkBoxDisabledClass}`}
                          id="sms"
                          onClick={(e) =>
                            this.setState({
                              commercialSmsChoice: e.target.checked,
                            })
                          }
                          label={
                            CONSTANTS.LABELS.userinfos_consent_checkbox_sms
                          }
                          isChecked={this.props.store.personalInfos.ConsentSms}
                        />
                      )}
                      {ActivatePostmail && (
                        <CheckBox
                          wrapperClasses="commercial-choice"
                          id="adress"
                          onClick={(e) =>
                            this.setState({
                              commercialAdressChoice: e.target.checked,
                            })
                          }
                          label={
                            CONSTANTS.LABELS.userinfos_consent_checkbox_adress
                          }
                          isChecked={
                            this.props.store.personalInfos.ConsentAddress
                          }
                        />
                      )}
                      {ActivateOther && (
                        <CheckBox
                          wrapperClasses="commercial-choice"
                          id="other"
                          onClick={(e) =>
                            this.setState({
                              commercialOtherChoice: e.target.checked,
                            })
                          }
                          label={
                            CONSTANTS.LABELS.userinfos_consent_checkbox_other
                          }
                          isChecked={
                            this.props.store.personalInfos.ConsentOther
                          }
                        />
                      )}
                    </div>
                    <div
                      tabIndex="0"
                      dangerouslySetInnerHTML={{
                        __html: CONSTANTS.LABELS.userinfos_consent_block3,
                      }}
                    ></div>
                  </React.Fragment>
                )}

                {this.state.isNewConsentActive && (
                  <React.Fragment>
                    <div className="newConsentTitle newConsentMargin">
                      {CONSTANTS.LABELS.userinfos_newconsent_title1}
                    </div>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: CONSTANTS.LABELS.userinfos_newconsent_label1,
                      }}
                      className="newConsentMargin newConsentLineHeight"
                    ></div>

                    <div className="newConsentTitleRadioContainer">
                      <div className="newConsentTitle">
                        {CONSTANTS.LABELS.userinfos_newconsent_title2}
                      </div>
                      <Radio
                        name="marketingProfiling"
                        id="marketingProfiling-yes"
                        label={CONSTANTS.LABELS.common_yes}
                        checked={this.state.marketingProfilingInput === true}
                        onChange={(e) =>
                          this.setState({
                            marketingProfilingInput: true,
                            marketingInput: true,
                            profilingInput: true,
                          })
                        }
                        customDivStyle={{ margin: 0 }}
                        customLabelStyle={{ verticalAlign: "unset" }}
                        customInputStyle={{ position: "relative" }}
                      />
                      <Radio
                        name="marketingProfiling"
                        id="marketingProfiling-no"
                        label={CONSTANTS.LABELS.common_no}
                        checked={this.state.marketingProfilingInput === false}
                        onChange={(e) =>
                          this.setState({
                            marketingProfilingInput: false,
                            marketingInput: false,
                            profilingInput: false,
                          })
                        }
                        customDivStyle={{ margin: 0 }}
                        customLabelStyle={{ verticalAlign: "unset" }}
                        customInputStyle={{ position: "relative" }}
                      />
                    </div>

                    <div
                      className="newConsentLineHeight"
                      dangerouslySetInnerHTML={{
                        __html: CONSTANTS.LABELS.userinfos_newconsent_label2,
                      }}
                    ></div>
                    <div
                      className="newConsentLineHeight"
                      dangerouslySetInnerHTML={{
                        __html: CONSTANTS.LABELS.userinfos_newconsent_label3,
                      }}
                    ></div>
                    <div
                      className="newConsentLineHeight"
                      dangerouslySetInnerHTML={{
                        __html: CONSTANTS.LABELS.userinfos_newconsent_label4,
                      }}
                    ></div>
                    <div className="newConsentMargin newConsentLineHeight">
                      {CONSTANTS.LABELS.userinfos_newconsent_expand1}{" "}
                      <span
                        className="newConsentExpand"
                        onClick={() =>
                          this.setState({
                            isNewConsentExpanded: !this.state
                              .isNewConsentExpanded,
                          })
                        }
                      >
                        {CONSTANTS.LABELS.userinfos_newconsent_expand2}
                        <img
                          src={arrowExpand}
                          width={window.isMobile() ? 17 : 18}
                          className={`arrowExpand ${
                            this.state.isNewConsentExpanded
                              ? "expandUp"
                              : "expandDown"
                          }`}
                        />
                      </span>
                    </div>

                    {
                      <React.Fragment>
                        <div
                          style={{
                            display: this.state.isNewConsentExpanded
                              ? undefined
                              : "none",
                          }}
                        >
                          <div className="newConsentTitleRadioContainer">
                            <div className="newConsentTitle">
                              {CONSTANTS.LABELS.userinfos_newconsent_title3}
                            </div>
                            <Radio
                              name="marketing"
                              id="marketing-yes"
                              label={CONSTANTS.LABELS.common_yes}
                              checked={this.state.marketingInput === true}
                              onChange={(e) => {
                                this.setState({ marketingInput: true });
                                if (this.state.profilingInput) {
                                  this.setState({
                                    marketingProfilingInput: true,
                                  });
                                }
                              }}
                              customDivStyle={{ margin: 0 }}
                              customLabelStyle={{ verticalAlign: "unset" }}
                              customInputStyle={{ position: "relative" }}
                            />
                            <Radio
                              name="marketing"
                              id="marketing-no"
                              label={CONSTANTS.LABELS.common_no}
                              checked={this.state.marketingInput === false}
                              onChange={(e) => {
                                this.setState({ marketingInput: false });
                                if (this.state.profilingInput === false) {
                                  this.setState({
                                    marketingProfilingInput: false,
                                  });
                                }
                              }}
                              customDivStyle={{ margin: 0 }}
                              customLabelStyle={{ verticalAlign: "unset" }}
                              customInputStyle={{ position: "relative" }}
                            />
                          </div>

                          <div
                            className="newConsentMargin newConsentLineHeight"
                            dangerouslySetInnerHTML={{
                              __html:
                                CONSTANTS.LABELS.userinfos_newconsent_label5,
                            }}
                          ></div>

                          <div className="newConsentTitleRadioContainer">
                            <div className="newConsentTitle">
                              {CONSTANTS.LABELS.userinfos_newconsent_title4}
                            </div>
                            <Radio
                              name="profiling"
                              id="profiling-yes"
                              label={CONSTANTS.LABELS.common_yes}
                              checked={this.state.profilingInput === true}
                              onChange={(e) => {
                                this.setState({ profilingInput: true });
                                if (this.state.marketingInput) {
                                  this.setState({
                                    marketingProfilingInput: true,
                                  });
                                }
                              }}
                              customDivStyle={{ margin: 0 }}
                              customLabelStyle={{ verticalAlign: "unset" }}
                              customInputStyle={{ position: "relative" }}
                            />
                            <Radio
                              name="profiling"
                              id="profiling-no"
                              label={CONSTANTS.LABELS.common_no}
                              checked={this.state.profilingInput === false}
                              onChange={(e) => {
                                this.setState({ profilingInput: false });
                                if (this.state.marketingInput === false) {
                                  this.setState({
                                    marketingProfilingInput: false,
                                  });
                                }
                              }}
                              customDivStyle={{ margin: 0 }}
                              customLabelStyle={{ verticalAlign: "unset" }}
                              customInputStyle={{ position: "relative" }}
                            />
                          </div>

                          <div
                            className="newConsentMargin newConsentLineHeight"
                            dangerouslySetInnerHTML={{
                              __html:
                                CONSTANTS.LABELS.userinfos_newconsent_label6,
                            }}
                          ></div>
                        </div>
                      </React.Fragment>
                    }

                    <div className="newConsentTitleRadioContainer">
                      <div className="newConsentTitle">
                        {CONSTANTS.LABELS.userinfos_newconsent_title5}
                      </div>
                      <Radio
                        name="thirdParty"
                        id="thirdParty-yes"
                        label={CONSTANTS.LABELS.common_yes}
                        checked={this.state.thirdPartyInput === true}
                        onChange={(e) =>
                          this.setState({ thirdPartyInput: true })
                        }
                        customDivStyle={{ margin: 0 }}
                        customLabelStyle={{ verticalAlign: "unset" }}
                        customInputStyle={{ position: "relative" }}
                      />
                      <Radio
                        name="thirdParty"
                        id="thirdParty-no"
                        label={CONSTANTS.LABELS.common_no}
                        checked={this.state.thirdPartyInput === false}
                        onChange={(e) =>
                          this.setState({ thirdPartyInput: false })
                        }
                        customDivStyle={{ margin: 0 }}
                        customLabelStyle={{ verticalAlign: "unset" }}
                        customInputStyle={{ position: "relative" }}
                      />
                    </div>

                    <div
                      className="newConsentLineHeight"
                      dangerouslySetInnerHTML={{
                        __html: CONSTANTS.LABELS.userinfos_newconsent_label7,
                      }}
                    ></div>
                  </React.Fragment>
                )}

                {this.ActivateMentionLegal &&
                  CONSTANTS.SITE_INFO.BRAND_CODE !== "V" && (
                    <strong className="headline" tabIndex="0">
                      {CONSTANTS.LABELS.userinfos_legal_notice_title}
                    </strong>
                  )}
                {this.ActivateMentionLegal && (
                  <CheckBox
                    wrapperClasses="legal-choice"
                    id="legal-choice"
                    label={CONSTANTS.LABELS.userinfos_legal_notice}
                    isChecked={
                      this.props.store.personalInfos.acceptLegalNotices
                    }
                    onClick={(e) => {
                      this.setState({ islegalChoiceChecked: e.target.checked });
                    }}
                  />
                )}
                <div id="legal-mentions" className="pop-overlay">
                  <div className="popup">
                    <h2>{CONSTANTS.LABELS.userinfos_legal_notice_title}</h2>
                    <a className="close" href="#">
                      &times;
                    </a>
                    <div
                      className="content"
                      dangerouslySetInnerHTML={{
                        __html: CONSTANTS.SITE_INFO.MENTIONLEGAL,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{ marginBottom: this.state.confirmButtonMarginBottom }}
              className="form-ligne submit-button"
            >
              <Button
                Disabled={
                  this.state.isActivateTurquieConsent?
                  (!this.state.commercialEmailChoice) :
                  !this.state.islegalChoiceChecked ||
                  (this.state.isNewConsentActive &&
                    (this.state.marketingProfilingInput === "" ||
                      this.state.thirdPartyInput === ""))
                }
                onClick={(e) => {
                  this.validateFormInputs()
                    ? this.setState({ goToNextStep: true })
                    : this.scrollToTop();
                }}
              >
                {CONSTANTS.LABELS.common_v2_nextstep}
              </Button>
            </div>
          </LayoutStandardWidth>
        )}

        {/* CitroenBlock */}
        {CONSTANTS.SITE_INFO.BRAND_CODE === "C" && (
          <div className="rootCitroenInfosContainer" ref={this.formCitroenRef}>
            <div className="formAndServiceContainer">
              <div className="formAndConsentContainer">
                <div className="formContainer">
                  <div className="formRowContainer">
                    <div
                      tabIndex="0"
                      className={
                        this.state.showFormErrors &&
                        this.state.civilityInput !== "Common_Sir" &&
                        this.state.civilityInput !== "Common_Madam" &&
                        this.state.civilityInput !== "Common_Neutre"
                          ? "inputLabel onError"
                          : "inputLabel"
                      }
                    >
                      {CONSTANTS.LABELS.userinfos_civility}
                    </div>
                    <div className="radioButtonsContainer">
                      <Radio
                        name="civility"
                        id="civility-M"
                        label={CONSTANTS.LABELS.userinfos_mister}
                        value="Common_Sir"
                        isChecked={this.state.civilityInput === "Common_Sir"}
                        onChange={(e) =>
                          this.setState({ civilityInput: e.target.value })
                        }
                        customLabelStyle={{
                          color:
                            this.state.civilityInput === "Common_Sir"
                              ? "#57718a"
                              : "#3b3938",
                        }}
                      />
                      <Radio
                        name="civility"
                        id="civility-F"
                        label={CONSTANTS.LABELS.userinfos_madam}
                        value="Common_Madam"
                        isChecked={this.state.civilityInput == "Common_Madam"}
                        onChange={(e) =>
                          this.setState({ civilityInput: e.target.value })
                        }
                        customLabelStyle={{
                          color:
                            this.state.civilityInput === "Common_Madam"
                              ? "#57718a"
                              : "#3b3938",
                        }}
                      />
                      {ShowGenderNeutre && (
                        <Radio
                          name="civility"
                          id="civility-N"
                          label={CONSTANTS.LABELS.userinfos_neutral}
                          value="Common_Neutre"
                          isChecked={
                            this.state.civilityInput == "Common_Neutre"
                          }
                          onChange={(e) =>
                            this.setState({ civilityInput: e.target.value })
                          }
                          customLabelStyle={{
                            color:
                              this.state.civilityInput === "Common_Neutre"
                                ? "#57718a"
                                : "#3b3938",
                          }}
                        />
                      )}
                      {this.state.showFormErrors &&
                        this.state.civilityInput !== "Common_Sir" &&
                        this.state.civilityInput !== "Common_Madam" &&
                        this.state.civilityInput !== "Common_Neutre" && (
                          <span className="error input-errorLabel">
                            {CONSTANTS.LABELS.userinfos_error.replace(
                              FIELED_NAME_STRING_TOREPLACE,
                              CONSTANTS.LABELS.userinfos_civility
                            )}
                          </span>
                        )}
                    </div>
                  </div>
                  <div className="formRowContainer">
                    <div
                      tabIndex="0"
                      className={
                        (this.state.showFormErrors &&
                          this.state.firstNameInput.length < 2) ||
                        this.getAlertLabelFirstNameError()
                          ? "inputLabel onError"
                          : "inputLabel"
                      }
                    >
                      {CONSTANTS.LABELS.userinfos_firstname}
                    </div>
                    <div className="inputContainer">
                      <InputOutlined
                        ariaLabel={CONSTANTS.LABELS.userinfos_firstname}
                        value={this.state.firstNameInput}
                        name={"firstName"}
                        autoComplete={"on"}
                        isValid={
                          this.state.isValidFirstName &&
                          this.state.firstNameInput.length > 0
                        }
                        onChange={(e) => {
                          if (e.target.value.trim().match(/[0-9]/g)) {
                            this.setState({
                              firstNameInput: removeNumbers(
                                e.target.value.trim()
                              ),
                              showFirstNameFormatError: true,
                              showSpecialCharFormatError: false,
                              showFirstNameMaxLengthError: false,
                              isValidFirstName: false,
                            });
                          } else if (
                            e.target.value.match(/[^\p{L}\p{M}\s']/gu)
                          ) {
                            this.setState({
                              showSpecialCharFormatError: true,
                              showFirstNameMaxLengthError: false,
                              showFirstNameFormatError: false,
                              isValidFirstName: false,
                            });
                          } else if (e.target.value.length > 50) {
                            this.setState({
                              showFirstNameMaxLengthError: true,
                              showFirstNameFormatError: false,
                              showSpecialCharFormatError: false,
                              isValidFirstName: false,
                            });
                          } else {
                            this.setState({
                              firstNameInput: e.target.value,
                              showFirstNameFormatError: false,
                              showSpecialCharFormatError: false,
                              showFirstNameMaxLengthError: false,
                              isValidFirstName: true,
                            });
                          }
                        }}
                        isInvalid={
                          (this.state.showFormErrors &&
                            this.state.firstNameInput.length < 2 &&
                            CONSTANTS.LABELS.userinfos_error.replace(
                              FIELED_NAME_STRING_TOREPLACE,
                              CONSTANTS.LABELS.userinfos_firstname
                            )) ||
                          this.getAlertLabelFirstNameError()
                        }
                      />
                    </div>
                  </div>

                  <div className="formRowContainer">
                    <div
                      tabIndex="0"
                      className={
                        (this.state.showFormErrors &&
                          this.state.lastNameInput.length < 2) ||
                        this.getAlertLabelNameError()
                          ? "inputLabel onError"
                          : "inputLabel"
                      }
                    >
                      {CONSTANTS.LABELS.userinfos_lastname}
                    </div>
                    <div className="inputContainer">
                      <InputOutlined
                        ariaLabel={CONSTANTS.LABELS.userinfos_lastname}
                        value={removeNumbers(this.state.lastNameInput)}
                        name={"lastName"}
                        autoComplete={"on"}
                        isValid={
                          this.state.isValidLastName &&
                          this.state.lastNameInput.length > 0
                        }
                        onChange={(e) => {
                          if (e.target.value.trim().match(/[0-9]/g)) {
                            this.setState({
                              lastNameInput: removeNumbers(
                                e.target.value.trim()
                              ),
                              showNameFormatError: true,
                              showNameSpecialCharError: false,
                              showNameMaxLengthError: false,
                              isValidLastName: false,
                            });
                          } else if (
                            e.target.value.match(/[^\p{L}\p{M}\s']/gu)
                          ) {
                            this.setState({
                              showNameSpecialCharError: true,
                              showNameFormatError: false,
                              showNameMaxLengthError: false,
                              isValidLastName: false,
                            });
                          } else if (e.target.value.length > 50) {
                            this.setState({
                              showNameMaxLengthError: true,
                              showNameSpecialCharError: false,
                              showNameFormatError: false,
                              isValidLastName: false,
                            });
                          } else {
                            this.setState({
                              lastNameInput: e.target.value,
                              showNameSpecialCharError: false,
                              showNameFormatError: false,
                              showNameMaxLengthError: false,
                              isValidLastName: true,
                            });
                          }
                        }}
                        isInvalid={
                          (this.state.showFormErrors &&
                            this.state.lastNameInput.length < 2 &&
                            CONSTANTS.LABELS.userinfos_error.replace(
                              FIELED_NAME_STRING_TOREPLACE,
                              CONSTANTS.LABELS.userinfos_lastname
                            )) ||
                          this.getAlertLabelNameError()
                        }
                      />
                    </div>
                  </div>
                  <div className="formRowContainer">
                    <div
                      tabIndex="0"
                      className={
                        this.state.showFormErrors &&
                        !this.state.emailInput.match(
                          /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}/g
                        )
                          ? "inputLabel onError"
                          : "inputLabel"
                      }
                    >
                      {CONSTANTS.LABELS.userinfos_email}
                    </div>
                    <div className="inputContainer">
                      <InputOutlined
                        ariaLabel={CONSTANTS.LABELS.userinfos_email}
                        name="email"
                        autoComplete={"on"}
                        placeholder={CONSTANTS.SITE_INFO.EMAILMASK}
                        defaultValue={this.state.emailInput}
                        isValid={
                          this.state.isValidEmail &&
                          this.state.emailInput.length > 0
                        }
                        onChange={(e) =>
                          this.setState({
                            emailInput: e.target.value.match(
                              /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}/g
                            )
                              ? e.target.value.toLowerCase().trim()
                              : "",
                            isValidEmail: e.target.value.match(
                              /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}/g
                            )
                              ? true
                              : false,
                          })
                        }
                        isInvalid={
                          this.state.showFormErrors &&
                          !this.state.emailInput.match(
                            /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}/g
                          ) &&
                          CONSTANTS.LABELS.userinfos_error.replace(
                            FIELED_NAME_STRING_TOREPLACE,
                            CONSTANTS.LABELS.userinfos_email
                          )
                        }
                      />
                    </div>
                  </div>
                  <div className="formRowContainer">
                    <div
                      tabIndex="0"
                      className={
                        this.state.showFormErrors &&
                        !getNewPhoneFormatValue(this.state.phoneInput).match(
                          CONSTANTS.SITE_INFO.PHONEREGEX
                        ) &&
                        (Number(this.state.phoneInput) < 1 ||
                          this.state.phoneInput.length !== 20)
                          ? "inputLabel onError"
                          : "inputLabel"
                      }
                    >
                      {CONSTANTS.LABELS.userinfos_tel}
                    </div>
                    <div className="inputContainer">
                      <InputOutlined
                        ariaLabel={CONSTANTS.LABELS.userinfos_tel}
                        type="tel"
                        name="tel"
                        autoComplete={"on"}
                        placeholder={getNewPhoneFormatValue(
                          CONSTANTS.SITE_INFO.PHONEMASK
                        )}
                        value={getNewPhoneFormatValue(this.state.phoneInput)}
                        onChange={(e) => {
                          if (
                            e.currentTarget.value.match(
                              CONSTANTS.SITE_INFO.PHONEREGEX
                            )
                          ) {
                            this.setState({
                              phoneInput: e.currentTarget.value.trim(),
                            });
                          } else if (
                            Number(e.currentTarget.value) < 1 &&
                            e.currentTarget.value.length > 1
                          ) {
                            this.setState({
                              phoneInput: e.currentTarget.value.slice(0, -1),
                            });
                          } else {
                            this.setState({
                              phoneInput: getNewPhoneFormatValue(
                                e.currentTarget.value.trim()
                              ),
                            });
                          }
                        }}
                        isInvalid={
                          this.state.showFormErrors &&
                          !getNewPhoneFormatValue(this.state.phoneInput).match(
                            CONSTANTS.SITE_INFO.PHONEREGEX
                          ) &&
                          (Number(this.state.phoneInput) < 1 ||
                            this.state.phoneInput.length !== 20) &&
                          CONSTANTS.LABELS.userinfos_error.replace(
                            FIELED_NAME_STRING_TOREPLACE,
                            CONSTANTS.LABELS.userinfos_tel
                          )
                        }
                      />
                    </div>
                  </div>
                  <div className="formRowContainer">
                    <div tabIndex="0" className="inputLabel">
                      {CONSTANTS.LABELS.userinfos_contact_mode}
                    </div>
                    <div className="inputContainer">
                      <Select
                        customClassName={"selectDropdown"}
                        ariaLabel={CONSTANTS.LABELS.userinfos_contact_mode}
                        Options={options}
                        Selected={this.state.contactModeOption}
                        Name="contactChoice"
                        onChange={(e) => {
                          this.setState({
                            contactModeOption: e.target.value.trim(),
                          });
                          this.setState({
                            contactModeInput: e.target.options[
                              e.target.selectedIndex
                            ].text.trim(),
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>

                {this.state.showOptionPremiumSerives &&
                  this.isMobile() === "mobile" && (
                    <div className="premiumServicesContainer">
                      <div className="premiumServicesTitle">
                        {CONSTANTS.LABELS.userinfos_options_title}
                      </div>
                      <div className="premiumServicesContent">
                        {this.state.listPremiumServices.map((premService) => {
                          return (
                            premService.displayPI &&
                            this.props.store.dealer.ListeIdSP.includes(
                              premService.idServicePremium
                            ) && (
                              <PremiumServiceItem
                                Title={premService.titre}
                                Price={""}
                                Description={premService.label}
                                Name={premService.titre}
                                Label={
                                  CONSTANTS.LABELS.userinfos_options_checkbox
                                }
                                isSelected={this.state.selectedPremiumServices.some(
                                  (elemt) =>
                                    elemt.idServicePremium ===
                                    premService.idServicePremium
                                )}
                                onChange={(e) => {
                                  e.target.checked
                                    ? this.setState({
                                        selectedPremiumServices: [
                                          ...this.state.selectedPremiumServices,
                                          {
                                            idServicePremium:
                                              premService.idServicePremium,
                                            groupe: premService.groupe,
                                          },
                                        ],
                                        premiumServicesCodeIntern: [
                                          ...this.state
                                            .premiumServicesCodeIntern,
                                          premService.codeIntern,
                                        ],
                                      })
                                    : this.setState({
                                        selectedPremiumServices: this.state.selectedPremiumServices.filter(
                                          (item) =>
                                            item.idServicePremium !==
                                            premService.idServicePremium
                                        ),
                                      });
                                }}
                              />
                            )
                          );
                        })}
                      </div>
                    </div>
                  )}
              </div>

              {this.state.showOptionPremiumSerives &&
                this.isMobile() === "desktop" && (
                  <div className="premiumServicesContainer">
                    <div className="premiumServicesTitle">
                      {CONSTANTS.LABELS.userinfos_options_title}
                    </div>
                    <div className="premiumServicesContent">
                      {this.state.listPremiumServices.map((premService) => {
                        return (
                          premService.displayPI &&
                          this.props.store.dealer.ListeIdSP.includes(
                            premService.idServicePremium
                          ) && (
                            <PremiumServiceItem
                              Title={premService.titre}
                              Price={""}
                              Description={premService.label}
                              Name={premService.titre}
                              Label={
                                CONSTANTS.LABELS.userinfos_options_checkbox
                              }
                              isSelected={this.state.selectedPremiumServices.some(
                                (elemt) =>
                                  elemt.idServicePremium ===
                                  premService.idServicePremium
                              )}
                              onChange={(e) => {
                                e.target.checked
                                  ? this.setState({
                                      selectedPremiumServices: [
                                        ...this.state.selectedPremiumServices,
                                        {
                                          idServicePremium:
                                            premService.idServicePremium,
                                          groupe: premService.groupe,
                                        },
                                      ],
                                      premiumServicesCodeIntern: [
                                        ...this.state.premiumServicesCodeIntern,
                                        premService.codeIntern,
                                      ],
                                    })
                                  : this.setState({
                                      selectedPremiumServices: this.state.selectedPremiumServices.filter(
                                        (item) =>
                                          item.idServicePremium !==
                                          premService.idServicePremium
                                      ),
                                    });
                              }}
                            />
                          )
                        );
                      })}
                    </div>
                  </div>
                )}
            </div>
            {/* edit the alignment RN ##*/}
            {!this.state.isNewConsentActive && (
                  <div className="consentContainer">
                    <React.Fragment>
                      <div
                        tabIndex="0"
                        className="consentTitle"
                        dangerouslySetInnerHTML={{
                          __html: CONSTANTS.LABELS.userinfos_consent_block1,
                        }}
                      ></div>

                      {this.acceptCommercialChoiceCheckboxIsActivated ? (
                        <CheckBox
                          wrapperClasses="accept-commercial-choice"
                          id="accept-commercials"
                          onClick={(e) => {
                            var cbs = document.getElementsByClassName(
                              "commercial-choice"
                            );
                            for (var i = 0; i < cbs.length; i++) {
                              cbs[i].firstChild.checked = false;
                            }
                            this.setState({
                              acceptCommercialChoice: e.target.checked,
                              commercialEmailChoice: false,
                              commercialTelChoice: false,
                              commercialSmsChoice: false,
                              commercialAdressChoice: false,
                              commercialOtherChoice: false,
                            });
                          }}
                          label={CONSTANTS.LABELS.userinfos_consent_block2}
                          isChecked={
                            this.props.store.personalInfos
                              .ConsentToAcceptCommercialChoice
                          }
                        />
                      ) : (
                        <div
                          className="consentTitle"
                          tabIndex="0"
                          dangerouslySetInnerHTML={{
                            __html: CONSTANTS.LABELS.userinfos_consent_block2,
                          }}
                        ></div>
                      )}

                      <div
                        aria-disabled={
                          !this.state.acceptCommercialChoice &&
                          this.acceptCommercialChoiceCheckboxIsActivated
                        }
                        className={
                          !this.state.acceptCommercialChoice &&
                          this.acceptCommercialChoiceCheckboxIsActivated
                            ? "is-disabled commercialChoiceContainer"
                            : "commercialChoiceContainer"
                        }
                      >
                        {ActivateEmail && (
                          <CheckBox
                            wrapperClasses={
                              this.state.commercialEmailChoice
                                ? "commercial-choice isSelected"
                                : "commercial-choice"
                            }
                            id="email"
                            onClick={(e) =>
                              this.setState({
                                commercialEmailChoice: e.target.checked,
                              })
                            }
                            label={
                              CONSTANTS.LABELS.userinfos_consent_checkbox_email
                            }
                            isChecked={
                              this.props.store.personalInfos.ConsentEmail
                            }
                          />
                        )}
                        {ActivateTelephone && (
                          <CheckBox
                            wrapperClasses={
                              this.state.commercialTelChoice
                                ? `commercial-choice ${checkBoxDisabledClass} isSelected`
                                : `commercial-choice ${checkBoxDisabledClass}`
                            }
                            id="tel"
                            onClick={(e) =>
                              this.setState({
                                commercialTelChoice: e.target.checked,
                              })
                            }
                            label={
                              CONSTANTS.LABELS.userinfos_consent_checkbox_tel
                            }
                            isChecked={
                              this.props.store.personalInfos.ConsentTel
                            }
                          />
                        )}
                        {ActivateSMS && (
                          <CheckBox
                            wrapperClasses={
                              this.state.commercialSmsChoice
                                ? `commercial-choice ${checkBoxDisabledClass} isSelected`
                                : `commercial-choice ${checkBoxDisabledClass}`
                            }
                            id="sms"
                            onClick={(e) =>
                              this.setState({
                                commercialSmsChoice: e.target.checked,
                              })
                            }
                            label={
                              CONSTANTS.LABELS.userinfos_consent_checkbox_sms
                            }
                            isChecked={
                              this.props.store.personalInfos.ConsentSms
                            }
                          />
                        )}
                        {ActivatePostmail && (
                          <CheckBox
                            wrapperClasses={
                              this.state.commercialAdressChoice
                                ? "commercial-choice isSelected"
                                : "commercial-choice"
                            }
                            id="adress"
                            onClick={(e) =>
                              this.setState({
                                commercialAdressChoice: e.target.checked,
                              })
                            }
                            label={
                              CONSTANTS.LABELS.userinfos_consent_checkbox_adress
                            }
                            isChecked={
                              this.props.store.personalInfos.ConsentAddress
                            }
                          />
                        )}
                        {ActivateOther && (
                          <CheckBox
                            wrapperClasses={
                              this.state.commercialOtherChoice
                                ? "commercial-choice isSelected"
                                : "commercial-choice"
                            }
                            id="other"
                            onClick={(e) =>
                              this.setState({
                                commercialOtherChoice: e.target.checked,
                              })
                            }
                            label={
                              CONSTANTS.LABELS.userinfos_consent_checkbox_other
                            }
                            isChecked={
                              this.props.store.personalInfos.ConsentOther
                            }
                          />
                        )}
                      </div>
                      <div
                        className="consentTitle2"
                        tabIndex="0"
                        dangerouslySetInnerHTML={{
                          __html: CONSTANTS.LABELS.userinfos_consent_block3,
                        }}
                      ></div>
                    </React.Fragment>
                  </div>
                )}

            {/* NewConsentPart */}
            {this.state.isNewConsentActive && (
                  <div className="newConsentContainer">
                    <div className="newConsentTitle newConsentMargin">
                      {CONSTANTS.LABELS.userinfos_newconsent_title1}
                    </div>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: CONSTANTS.LABELS.userinfos_newconsent_label1,
                      }}
                      className="newConsentMargin newConsentLineHeight newConsentSubTitle"
                    ></div>

                    <div className="newConsentTitleRadioContainer">
                      <div className="newConsentTitle">
                        {CONSTANTS.LABELS.userinfos_newconsent_title2}
                      </div>
                      <Radio
                        name="marketingProfiling"
                        id="marketingProfiling-yes"
                        label={CONSTANTS.LABELS.common_yes}
                        checked={this.state.marketingProfilingInput === true}
                        onChange={(e) =>
                          this.setState({
                            marketingProfilingInput: true,
                            marketingInput: true,
                            profilingInput: true,
                          })
                        }
                        customDivStyle={{ margin: 0 }}
                        customLabelStyle={{ verticalAlign: "unset" }}
                        customInputStyle={{ position: "relative" }}
                      />
                      <Radio
                        name="marketingProfiling"
                        id="marketingProfiling-no"
                        label={CONSTANTS.LABELS.common_no}
                        checked={this.state.marketingProfilingInput === false}
                        onChange={(e) =>
                          this.setState({
                            marketingProfilingInput: false,
                            marketingInput: false,
                            profilingInput: false,
                          })
                        }
                        customDivStyle={{ margin: 0 }}
                        customLabelStyle={{ verticalAlign: "unset" }}
                        customInputStyle={{ position: "relative" }}
                      />
                    </div>

                    <div
                      className="newConsentSubTitle newConsentLineHeight"
                      dangerouslySetInnerHTML={{
                        __html: CONSTANTS.LABELS.userinfos_newconsent_label2,
                      }}
                    ></div>
                    <div
                      className="newConsentSubTitle newConsentLineHeight"
                      dangerouslySetInnerHTML={{
                        __html: CONSTANTS.LABELS.userinfos_newconsent_label3,
                      }}
                    ></div>
                    <div
                      className="newConsentSubTitle newConsentLineHeight"
                      dangerouslySetInnerHTML={{
                        __html: CONSTANTS.LABELS.userinfos_newconsent_label4,
                      }}
                    ></div>
                    <div className="newConsentSubTitle newConsentMargin newConsentLineHeight">
                      {CONSTANTS.LABELS.userinfos_newconsent_expand1}{" "}
                      <span
                        className="newConsentExpand"
                        onClick={() =>
                          this.setState({
                            isNewConsentExpanded: !this.state
                              .isNewConsentExpanded,
                          })
                        }
                      >
                        {CONSTANTS.LABELS.userinfos_newconsent_expand2}
                        <img
                          src={arrowExpand}
                          width={window.isMobile() ? 17 : 18}
                          className={`arrowExpand ${
                            this.state.isNewConsentExpanded
                              ? "expandUp"
                              : "expandDown"
                          }`}
                        />
                      </span>
                    </div>

                    {
                      <React.Fragment>
                        <div
                          style={{
                            display: this.state.isNewConsentExpanded
                              ? undefined
                              : "none",
                          }}
                        >
                          <div className="newConsentTitleRadioContainer">
                            <div className="newConsentTitle">
                              {CONSTANTS.LABELS.userinfos_newconsent_title3}
                            </div>
                            <Radio
                              name="marketing"
                              id="marketing-yes"
                              label={CONSTANTS.LABELS.common_yes}
                              checked={this.state.marketingInput === true}
                              onChange={(e) => {
                                this.setState({ marketingInput: true });
                                if (this.state.profilingInput) {
                                  this.setState({
                                    marketingProfilingInput: true,
                                  });
                                }
                              }}
                              customDivStyle={{ margin: 0 }}
                              customLabelStyle={{ verticalAlign: "unset" }}
                              customInputStyle={{ position: "relative" }}
                            />
                            <Radio
                              name="marketing"
                              id="marketing-no"
                              label={CONSTANTS.LABELS.common_no}
                              checked={this.state.marketingInput === false}
                              onChange={(e) => {
                                this.setState({ marketingInput: false });
                                if (this.state.profilingInput === false) {
                                  this.setState({
                                    marketingProfilingInput: false,
                                  });
                                }
                              }}
                              customDivStyle={{ margin: 0 }}
                              customLabelStyle={{ verticalAlign: "unset" }}
                              customInputStyle={{ position: "relative" }}
                            />
                          </div>

                          <div
                            className="newConsentSubTitle newConsentMargin newConsentLineHeight"
                            dangerouslySetInnerHTML={{
                              __html:
                                CONSTANTS.LABELS.userinfos_newconsent_label5,
                            }}
                          ></div>

                          <div className="newConsentTitleRadioContainer">
                            <div className="newConsentTitle">
                              {CONSTANTS.LABELS.userinfos_newconsent_title4}
                            </div>
                            <Radio
                              name="profiling"
                              id="profiling-yes"
                              label={CONSTANTS.LABELS.common_yes}
                              checked={this.state.profilingInput === true}
                              onChange={(e) => {
                                this.setState({ profilingInput: true });
                                if (this.state.marketingInput) {
                                  this.setState({
                                    marketingProfilingInput: true,
                                  });
                                }
                              }}
                              customDivStyle={{ margin: 0 }}
                              customLabelStyle={{ verticalAlign: "unset" }}
                              customInputStyle={{ position: "relative" }}
                            />
                            <Radio
                              name="profiling"
                              id="profiling-no"
                              label={CONSTANTS.LABELS.common_no}
                              checked={this.state.profilingInput === false}
                              onChange={(e) => {
                                this.setState({ profilingInput: false });
                                if (this.state.marketingInput === false) {
                                  this.setState({
                                    marketingProfilingInput: false,
                                  });
                                }
                              }}
                              customDivStyle={{ margin: 0 }}
                              customLabelStyle={{ verticalAlign: "unset" }}
                              customInputStyle={{ position: "relative" }}
                            />
                          </div>

                          <div
                            className="newConsentSubTitle newConsentMargin newConsentLineHeight"
                            dangerouslySetInnerHTML={{
                              __html:
                                CONSTANTS.LABELS.userinfos_newconsent_label6,
                            }}
                          ></div>
                        </div>
                      </React.Fragment>
                    }

                    <div className="newConsentTitleRadioContainer">
                      <div className="newConsentTitle">
                        {CONSTANTS.LABELS.userinfos_newconsent_title5}
                      </div>
                      <Radio
                        name="thirdParty"
                        id="thirdParty-yes"
                        label={CONSTANTS.LABELS.common_yes}
                        checked={this.state.thirdPartyInput === true}
                        onChange={(e) =>
                          this.setState({ thirdPartyInput: true })
                        }
                        customDivStyle={{ margin: 0 }}
                        customLabelStyle={{ verticalAlign: "unset" }}
                        customInputStyle={{ position: "relative" }}
                      />
                      <Radio
                        name="thirdParty"
                        id="thirdParty-no"
                        label={CONSTANTS.LABELS.common_no}
                        checked={this.state.thirdPartyInput === false}
                        onChange={(e) =>
                          this.setState({ thirdPartyInput: false })
                        }
                        customDivStyle={{ margin: 0 }}
                        customLabelStyle={{ verticalAlign: "unset" }}
                        customInputStyle={{ position: "relative" }}
                      />
                    </div>

                    <div
                      className="newConsentSubTitle newConsentLineHeight"
                      dangerouslySetInnerHTML={{
                        __html: CONSTANTS.LABELS.userinfos_newconsent_label7,
                      }}
                    ></div>
                  </div>
                )}

            {this.ActivateMentionLegal && (
                  <React.Fragment>
                    <div className="legalMentionsContainer">
                      <div className="legalMentionsTitle" tabIndex="0">
                        {CONSTANTS.LABELS.userinfos_legal_notice_title}
                      </div>
                      <CheckBox
                        wrapperClasses="legal-choice"
                        id="legal-choice"
                        label={CONSTANTS.LABELS.userinfos_legal_notice}
                        isChecked={
                          this.props.store.personalInfos.acceptLegalNotices
                        }
                        onClick={(e) => {
                          this.setState({
                            islegalChoiceChecked: e.target.checked,
                          });
                        }}
                      />
                    </div>
                    <div id="legal-mentions" className="pop-overlay">
                      <div className="popup">
                        <h2>{CONSTANTS.LABELS.userinfos_legal_notice_title}</h2>
                        <a className="close" href="#">
                          &times;
                        </a>
                        <div
                          className="content"
                          dangerouslySetInnerHTML={{
                            __html: CONSTANTS.SITE_INFO.MENTIONLEGAL,
                          }}
                        ></div>
                      </div>
                    </div>
                  </React.Fragment>
                )}    

            <div className="submitButtonCitroenContainer">
                  <Button
                    Disabled={

                      !this.state.islegalChoiceChecked ||
                      (this.state.isNewConsentActive &&
                        (this.state.marketingProfilingInput === "" ||
                          this.state.thirdPartyInput === ""))
                    }
                    onClick={(e) => {
                      this.validateFormInputs()
                        ? this.setState({ goToNextStep: true })
                        : window.scrollTo(
                            0,
                            this.formCitroenRef.current.offsetTop - 25
                          );
                    }}
                  >
                    {CONSTANTS.LABELS.common_v2_nextstep}
                  </Button>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(MyInfos);